export const medicalSpecality=[
  { "value": "family_medicine", "label": "Family Medicine (Family Doctor)" },
  { "value": "general_practice", "label": "General Practitioner (GP)" },
  { "value": "internal_medicine", "label": "Internal Medicine" },
  { "value": "pediatrics", "label": "Pediatrics (Children's Doctor)" },
  { "value": "cardiology", "label": "Cardiology (Heart)" },
  { "value": "dermatology", "label": "Dermatology (Skin)" },
  { "value": "endocrinology", "label": "Endocrinology (Diabetes & Hormones)" },
  { "value": "gastroenterology", "label": "Gastroenterology (Digestive System)" },
  { "value": "neurology", "label": "Neurology (Brain & Nervous System)" },
  { "value": "oncology", "label": "Oncology (Cancer)" },
  { "value": "orthopedics", "label": "Orthopedics (Bones & Joints)" },
  { "value": "psychiatry", "label": "Psychiatry (Mental Health)" },
  { "value": "obstetrics_gynecology", "label": "Obstetrics & Gynecology (OB-GYN)" },
  { "value": "ophthalmology", "label": "Ophthalmology (Eye Specialist)" },
  { "value": "ent", "label": "ENT (Ear, Nose & Throat)" },
  { "value": "urology", "label": "Urology" },
  { "value": "radiology", "label": "Radiology" },
  { "value": "anesthesiology", "label": "Anesthesiology" },
  { "value": "emergency_medicine", "label": "Emergency Medicine" },
  { "value": "pain_management", "label": "Pain Management" }
]
 